(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('SSEstatusProyecto', SSEstatusProyecto);

    SSEstatusProyecto.$inject = ['$resource', 'DateUtils'];

    function SSEstatusProyecto ($resource, DateUtils) {
        var resourceUrl =  'api/s-s-estatus-proyecto/:id';

        return $resource(resourceUrl, {}, {
            'all': { 
            	method: 'GET',
            	url:'api/s-s-estatus-proyecto-all',
            	isArray: true
           	},  
        });
    }
})();
